import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentMethodsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseGetPaymentMethodQueryProps = {
	paymentMethodId: number | string;
};

const useGetPaymentMethodQuery = ({
	paymentMethodId,
}: UseGetPaymentMethodQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["paymentMethod", paymentMethodId],
		() =>
			paymentMethodsService.getPaymentMethod({
				paymentMethodId,
			}),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!paymentMethodId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetPaymentMethodQuery;
